const defaultState = () => ({
  firebaseToken: null,
  consent: null
})

export const state = defaultState()

export const getters = {
  consent: state => state.consent
}

export const mutations = {
  RESET_STATE (state) {
    Object.assign(state, defaultState())
  },
  GET_NOTIFICATION_CONSENT (state) {
    const consent = localStorage?.getItem('push_notification_consent') || null
    state.consent = consent
  },
  SAVE_NOTIFICATION_CONSENT (state, consent) {
    localStorage?.setItem('push_notification_consent', consent)
    state.consent = consent
  },
  GET_FIREBASE_TOKEN (state) {
    const token = localStorage?.getItem('push_token') || null
    state.firebaseToken = token
  },
  SAVE_FIREBASE_TOKEN (state, token) {
    localStorage?.setItem('push_token', token)
    state.firebaseToken = token
  },
  REMOVE_FIREBASE_TOKEN (state) {
    localStorage?.removeItem('push_token')
    state.firebaseToken = null
  }
}

export const actions = {
  // Method will be executed before the app is initialized (see main.ts)
  init ({ commit }) {
    commit('GET_NOTIFICATION_CONSENT')
    commit('GET_FIREBASE_TOKEN')
  },
  saveNotificationConsent ({ commit }, consent) {
    commit('SAVE_NOTIFICATION_CONSENT', consent)
  },
  saveFirebaseToken ({ commit }, token) {
    commit('SAVE_FIREBASE_TOKEN', token)
  },
  removeFirebaseToken ({ commit }) {
    commit('REMOVE_FIREBASE_TOKEN')
  }
}
